import { z } from 'zod/v4'

export const ConnectionPlatforms = {
	GoogleAds: 'googleAds',
} as const

export const ConnectionStatus = {
	Pending: 'pending',
	Active: 'active',
	Inactive: 'inactive',
	AwaitingReauthorization: 'awaitingReauthorization',
	AwaitingAuth: 'awaitingAuth',
	Error: 'error',
	Archived: 'archived',
} as const

export const ConnectionPlatformValidator = z.enum([ConnectionPlatforms.GoogleAds])
export const ConnectionStatusValidator = z.enum([
	ConnectionStatus.Pending,
	ConnectionStatus.Active,
	ConnectionStatus.AwaitingReauthorization,
	ConnectionStatus.AwaitingAuth,
	ConnectionStatus.Inactive,
	ConnectionStatus.Error,
	ConnectionStatus.Archived,
])

export type ConnectionPlatform = z.infer<typeof ConnectionPlatformValidator>
export type ConnectionStatus = z.infer<typeof ConnectionStatusValidator>

export const ConnectionValidator = z.object({
	accountId: z.string(),
	accountName: z.string(),
	managerAccountId: z.string(),
	managerAccountName: z.string(),
	id: z.string(),
	platform: ConnectionPlatformValidator,
	status: ConnectionStatusValidator,
	createdAt: z.string(),
	createdBy: z.string(),
	rolesOwner: z.array(z.string()),
	rolesEditor: z.array(z.string()).nullable(),
	rolesViewer: z.array(z.string()).nullable(),
	name: z.string(),
	refreshToken: z.string(),
	workspaceId: z.string(),
})

export const WritableConnectionValidator = ConnectionValidator.omit({
	id: true,
	createdAt: true,
	createdBy: true,
})

export const CreateConnectionValidator = ConnectionValidator.omit({
	id: true,
	createdAt: true,
	createdBy: true,
	status: true,
	accountId: true,
	accountName: true,
	managerAccountId: true,
	managerAccountName: true,
	rolesEditor: true,
	rolesViewer: true,
})

export type BaseConnection = z.infer<typeof CreateConnectionValidator>

export type Connection = z.infer<typeof ConnectionValidator>
export type WritableConnection = z.infer<typeof WritableConnectionValidator>
